'use strict';
import angular from 'angular';
import './exportbuilder.layers.components';
import './exportbuilder.layers.directives';

angular.module('exportbuilder.layers', [
    'exportbuilder.layers.components',
    'exportbuilder.layers.directives'
]);